import React,  { useEffect, useState } from 'react'; // Add useState to the imports
import { useScrollPosition } from 'hooks/useScrollPosition';
import { useSettings } from 'providers/settings-provider';
import { HeaderLogo } from "./header-logo";
import { HeaderTopbar } from "./header-topbar";
import { cn } from "utils/cn";
import { Container } from "components/atoms";

function HeaderBase() {
  const { settings } = useSettings();
  const scrollPosition = useScrollPosition();
  const [headerStickyOn, setHeaderStickyOn] = useState(false);

  useEffect(() => {
    const isSticky = scrollPosition > settings.layouts.headerStickyOffset;
    setHeaderStickyOn(isSticky);
  }, [scrollPosition, settings]);

  useEffect(() => {
    if (headerStickyOn === true) {
      document.body.setAttribute('data-sticky-header', 'on');
    } else {
      document.body.removeAttribute('data-sticky-header');
    }
  }, [headerStickyOn]);

  return (
    <header
      className={cn(
        `flex items-center transition-[height] shrink-0 h-[80px] `,
        // settings.layouts.headerSticky &&
        //   headerStickyOn &&
        //   "transition-[height] fixed z-10 top-0 start-0 end-0 shadow-sm backdrop-blur-md bg-background/70"
      )}
    >
      <Container className="flex justify-between items-center lg:gap-4">
        <HeaderLogo />
        <HeaderTopbar />
      </Container>
    </header>
  );
}

export const Header = React.memo(HeaderBase);
